jQuery(function ($) {
	// If Checked, following selections appear in drop down: 'In Memory of', 'In Honor of'
	$('body').on('change', '#tribute', function () {
		tributeReset('full');
		if ($(this).is(':checked')) {
			$('.woocommerce-checkout-review-order').addClass('tribute-show');
      $('.woocommerce-checkout-review-order #npsp_Tribute_Type_c').select2();
			$('#npsp_Tribute_Type_c, #Tribute_Full_Name__c').prop('required', true);
		}
	});

	// Show related options based on tribute type selection
	$('body').on('change', '#npsp_Tribute_Type_c', function () {
		tributeReset('tribute');
		var tributeType = $(this).val();
		if (tributeType !== '') {
			tributeType = tributeType.toLowerCase();
			$('.woocommerce-checkout-review-order').addClass(tributeType + '-show');
		}
	});

	$('body').on('change', '.notify-cbx input', function () {
		tributeReset('notify');
		if ($(this).is(':checked')) {
			$('.woocommerce-checkout-review-order').addClass('tribute-notification-show');
      $('.woocommerce-checkout-review-order #tributeNotifyTypes').select2();
			$('#npsp_Notification_Recipient_Name_c, #tributeNotifyTypes').prop('required', true);
		}
	});

	$('body').on('change', '#occasionselect', function () {
		tributeReset('occasion');
		if ($(this).val() === 'other') {
			$('.woocommerce-checkout-review-order').addClass('honor-other-show');
			$('#Occasion__c').prop('required', true);
		}
	});

	$('body').on('change', '#tributeNotifyTypes', function () {
		tributeReset('notification');
		var notifyType = $(this).val();
		if (notifyType !== '') {
			if (notifyType === 'email') {
				$('#Notification_Email__c').prop('required', true);
			} else if (notifyType === 'phone') {
				$('#Notification_Phone__c').prop('required', true);
			} else if (notifyType === 'mail') {
				$('#tributestreet1, #tributecity, #tributestate, #tributezip').prop('required', true);
        $('.woocommerce-checkout-review-order #tributestate').select2();
			}
			$('.woocommerce-checkout-review-order').toggleClass('tribute-notification-' + notifyType + '-show');
		}
	});

	function tributeReset(section) {
		var sections = {};
		sections['notification'] = ['#Notification_Email__c', '#Notification_Phone__c', '#tributestreet1', '#tributestreet2', '#tributecity', '#tributestate', '#tributezip'];
		sections['occasion'] = ['#Occasion__c'];
		sections['notify'] = sections['notification'].concat(['#npsp_Notification_Recipient_Name_c', '#tributeNotifyTypes']);
		sections['tribute'] = sections['occasion'].concat(sections['notify'].concat(['#occasionselect', '.notify-cbx input']));
		sections['full'] = sections['tribute'].concat(['#npsp_Tribute_Type_c', '#Tribute_Full_Name__c']);

		var classes = {};
		classes['notification'] = ['tribute-notification-phone-show', 'tribute-notification-email-show', 'tribute-notification-mail-show'];
		classes['occasion'] = ['honor-other-show'];
		classes['notify'] = classes['notification'].concat(['tribute-notification-show']);
		classes['tribute'] = classes['notify'].concat(classes['occasion'].concat(['honor-show', 'memorial-show']));
		classes['full'] = classes['tribute'].concat(['tribute-show']);

		$('.woocommerce-checkout-review-order').removeClass(classes[section].join(' '));
		$(sections[section].join(', ')).val('').prop('required', false).prop('checked', false);
		$('#tribute, #memorynotecbx, #honornotecbx').val(1);
	}
});
